module.exports = __webpack_public_path__ + "static/media/download_white.6ca67953.svg";